import React from 'react'
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import Resizer from "react-image-file-resizer";
import i18n from './lang/i18n'

import defaultCover from '../assets/images/banner.jpg';
import defaultPic1 from '../assets/images/avatar.jpg';
const landscape = (16/9);
const square = (1/1);

export default class PicCropper extends React.Component {

    constructor(props) {
        super(props);
        var image = defaultPic1;

        if (this.props.source === null || this.props.source === "undefined") {
            if (this.props.type === "cover") {
                image = defaultCover;
            } else if (this.props.type === "pic1") {
                image = defaultPic1;
            } else {
                image = defaultPic1;
            }
        } else {
            image = this.props.source;
        }

        this.state = 
        {
            //src: this.props.type === "cover" ? defaultCover : defaultPic1,
            src: image,
            display: 0,
            cropResult: "",
        };
        this.onChangeImage = this.onChangeImage.bind(this);
        this.cropImage = this.cropImage.bind(this);
        this.getCropped = this.getCropped.bind(this);
        this.copper = null;
    }

    onChangeImage(e) {
        e.preventDefault();
        let files;
        if (e.dataTransfer) {
        files = e.dataTransfer.files;
        } else if (e.target) {
        files = e.target.files;
        }
        const reader = new FileReader();
        reader.onload = () => {
        this.setState({ src: reader.result });
        };
        if (files[0]) {
            console.log(files[0].type);
            //reader.readAsDataURL(files[0]);
            if (files[0].type == "image/png" || files[0].type == "image/jpg" || files[0].type == "image/jpeg" || files[0].type == "image/gif") {
                reader.readAsDataURL(files[0]);
                this.setState({ display: 1 });
            } else {
                alert(i18n.t("cropper_unsupported_file", "Das Dateiformat wird nicht unterstützt. Bitte verwenden ein PNG, JPG oder GIF."));
            }
        }
    }

    cropImage() {
        if (typeof this.cropper.getCroppedCanvas() === 'undefined') {
            return;
        }
        this.setState({
            cropResult: this.cropper.getCroppedCanvas().toDataURL(),
        });
    }

    getCropped() {
        if (typeof this.cropper.getCroppedCanvas() === 'undefined' || this.cropper.getCroppedCanvas() === null) {
            return null;
        } else {
            return this.cropper.getCroppedCanvas().toDataURL();
        }
    }

    render() {
        var cropperHeight = 300;
        if (this.state.display === 0) {
            cropperHeight = 0;
        } else {
            cropperHeight = 300;
        }
        return (
            <div style={{ width: "100%" }}>
                <input type="file" onChange={this.onChangeImage}/>
                <br />
                <br />
                <Cropper
                key={this.state.display}
                style={{ height: cropperHeight, width: "100%" }}
                zoomTo={0}
                // initialAspectRatio={16 / 9}
                aspectRatio={this.props.type === "cover" ? landscape : square}
                preview=".img-preview"
                src={this.state.src}
                viewMode={1}
                guides={true}
                minCropBoxHeight={10}
                minCropBoxWidth={10}
                background={true}
                responsive={true}
                autoCropArea={1}
                checkOrientation={false}
                zoomOnWheel={false}
                cropend={() => {
                    //this.cropImage();
                }}
                onInitialized={(instance) => {
                    this.cropper = instance;
                }}
                />
            </div>
        ) 
    }
}

const resizeFile = (file, width, height) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      width,
      height,
      "JPEG",
      100,
      0,
      (uri) => {
        console.log(uri);
      },
      "file"
    );
  });